import { POST_NEW_FACILITY_SUCCESS, POST_NEW_FACILITY_FAILURE } from "../constants/MyM";
import { postApi } from "../../utils/apiCall";

const postNewFacilitySuccess = (data) => {
  return {
    type: POST_NEW_FACILITY_SUCCESS,
    payload: data,
  };
};

const postNewFacilityFailure = (data) => {
  return {
    type: POST_NEW_FACILITY_FAILURE,
    payload: data,
  };
};

export const postNewFacility = (data) => {
  return async (dispatch, getState) => {
    const { error, result } = await postApi(`/add_fac_details_mym_web`, {
      ...data,
    });
    if (!error) {
      return dispatch(postNewFacilitySuccess(result));
    }
    return dispatch(postNewFacilityFailure(result));
  };
};
